import { styled } from '@mui/material';
import { colors, devices } from '../../styles';

export const VacanciesListContainer = styled('ul')`
  margin-top: 16px;
  padding-left: 0;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;

  @media (${devices.md}) {
    justify-content: space-evenly;
    flex-direction: row;
  }
`;

export const VacancyListItem = styled('li')`
  list-style: none;
  margin-top: 40px;
  font-size: 16px;

  @media (${devices.md}) {
    width: 480px;
  }

  h2 {
    color: ${colors.mainGray};
    font-size: 20px;
    text-transform: uppercase;
    font-weight: 700;
    margin-bottom: 24px;
  }

  h3 {
    margin-top: 24px 0 0;
    font-size: 18px;
  }
`;

export const RequirementsList = styled('ul')`
  padding: 0;

  li {
    margin-left: 22px;
    font-size: 16px;
    margin-top: 8px;

    &:first-of-type {
      margin-top: 16px;
    }
  }
`;

export const VacancyApplyLink = styled('a')`
  font-weight: 500;
  text-decoration: none;
  color: ${colors.blue};
`;
